import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateRows: '1fr 1fr',
    padding: '24px',
    width: '100%',
    height: 200,
    backgroundColor: theme.palette.background.paper
  },
  logoContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%'
  },
  image: {
    width: '22%',
    height: '100%'
  },
  nameContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-end',
    width: '100%'
  },
  skeleton: {
    width: '80%'
  }
}))
